import React from "react";
import { ListGroup, Row, Col } from "react-bootstrap";
import "../UsersLeaderboard/style.scss";

const UnitLeaderboard = (p) => {
  const dataRankedUnits = p.dataLeaderboard?.ranked_departments;
  return (
    <div className="users-leaderboard-wrapper">
      {dataRankedUnits &&
        dataRankedUnits?.map((a, index) => (
          <ListGroup
            key={index}
            className={`${p.departmentName == a.name ? "is-user" : ""}`}
          >
            <ListGroup.Item
              className={`${p.departmentName == a.name ? "is-user" : ""}`}
            >
              <Row>
                <Col xs={1} sm={1} md={1} className="leaderboard-count">
                  {a.rank}
                </Col>
                <Col xs={5} sm={5} md={5}>
                  <div className="unit-details">
                    <span className="leaderboard-fullname">{a.name}</span>
                    <span className="leaderboard-tier">
                      {a.members_count} members
                    </span>
                  </div>
                </Col>
                <Col xs={6} sm={6} md={6} className="unit-points">
                  <span className="leaderboard-fullname">
                    Total {a.total_points_label}
                  </span>
                  <span className="leaderboard-tier">
                    Avg {a.average_points_label}
                  </span>
                </Col>
              </Row>
            </ListGroup.Item>
          </ListGroup>
        ))}
    </div>
  );
};

export default UnitLeaderboard;
